import { createTheme } from '@mui/material/styles';

export const shapeTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#9FADFF',
      dark: '#9FADFF',
      main: '#445FFE',
      contrastText: '#F2F2F2',
    },
    secondary: {
      light: '#E291AE',
      dark: '#E291AE',
      main: '#DA1A5D',
      contrastText: '#F2F2F2',
    },
    background: {
      default: '#424242',
    },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
  },
});

export const shapeLightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#9FADFF',
      dark: '#9FADFF',
      main: '#445FFE',
      contrastText: '#F2F2F2',
    },
    secondary: {
      light: '#E291AE',
      dark: '#E291AE',
      main: '#DA1A5D',
      contrastText: '#F2F2F2',
    },
  },
  components: {
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          backgroundColor: '#F1F1F1 !important',
          color: '#828282 !important',
          '&.Mui-focused': {
            backgroundColor: '#828282 !important',
            color: '#F1F1F1 !important',
          },
        },
      },
    },
  },
});

export const styles = {};
